<template>
  <div class="box_wrap" ref="box_wrap">
    <div class="box_rorate bg1"></div>
    <div class="box_rorate bg2"></div>
    <!-- <div class="box_txt">
    </div> -->
    <div class="slot-wrap">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'textBgWave',
  props: ['color', 'width'],
  components: {},
  data () {
    return {}
  },
  mounted () {
    this.$refs.box_wrap.style.setProperty('--box-width', this.width)
    this.$refs.box_wrap.style.setProperty('--circleColor', this.color)
  },
  computed: {},
  methods: {}
}
</script>
<style scoped lang="scss">
.slot-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.box_wrap {
  --box-width: '';
  --box-width-mg: calc((var(--box-width) / 2) * -1);
  --box-width-big: calc(var(--box-width) + 5%);
  --box-width-big-mg: calc(((var(--box-width) + 5%) / 2) * -1);
  --box-width-small: calc(var(--box-width) - 3%);
  --box-width-small-mg: calc(((var(--box-width) - 3%) / 2) * -1);
  --circleColor: '';
}
.box_wrap {
  position: relative;
  width: calc(var(--box-width) + 20px);
  height: calc(var(--box-width) + 20px);
  border-radius: 100%;
  margin: 0 auto;
//   overflow: hidden;
}
.box_rorate {
  position: absolute;
//   left: 50%;
//   top: 50%;
  left: 50%;
    top: 27%;
  border-radius: 100%;
  opacity: 0.3;
}
.box_rorate:before,
.box_rorate:after {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  border-radius: 100%;
  content: "";
}
.box_rorate:before {
  left: -3%;
  top: -3%;
}
.box_rorate:after {
  left: 3%;
  top: 3%;
}

.box_rorate.bg1 {
  background: var(--circleColor);
  animation: circle_size 1.1s ease-in-out both, rotate360 4s linear infinite,
    radius_ani 6s linear infinite;
}
.box_rorate.bg1:before {
  background: var(--circleColor);
  animation: radius_ani 6s 0.5s linear infinite;
}
.box_rorate.bg1:after {
  background: var(--circleColor);
  animation: radius_ani 6s 1s linear infinite;
}
.box_rorate.bg2 {
  background: var(--circleColor);
  animation: circle_size 1.1s ease-in-out both, rotate360 3.5s linear infinite,
    radius_ani 5.5s linear infinite;
}
.box_rorate.bg2:before {
  background: var(--circleColor);
  animation: radius_ani 5.5s 0.5s linear infinite;
}
.box_rorate.bg2:after {
//   background: #ff0036;
  background: #ff52529e;
  animation: radius_ani 5.5s 1s linear infinite;
}

@keyframes circle_size {
  0% {
    width: 0;
    height: 0;
  }
  50% {
    width: var(--box-width-big);
    height: var(--box-width-big);
    margin: var(--box-width-big-mg) 0 0 var(--box-width-big-mg);
  }
  70% {
    width: var(--box-width-small);
    height: var(--box-width-small);
    margin: var(--box-width-small-mg) 0 0 var(--box-width-small-mg);
  }
  100% {
    width: var(--box-width);
    height: var(--box-width);
    margin: var(--box-width-mg) 0 0 var(--box-width-mg);
  }
}
@keyframes rotate360 {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes radius_ani {
  0% {
    border-radius: 100%;
  }
  10% {
    border-radius: 100% 70% 100%;
  }
  20% {
    border-radius: 91% 88% 75% 69%;
  }
  30% {
    border-radius: 100% 100% 85%;
  }
  40% {
    border-radius: 88% 100% 70%;
  }
  50% {
    border-radius: 75% 100% 100%;
  }
  60% {
    border-radius: 87% 78% 55% 84%;
  }
  70% {
    border-radius: 79% 90% 80% 72%;
  }
  80% {
    border-radius: 76% 92% 90% 77%;
  }
  90% {
    border-radius: 83% 77% 99% 88%;
  }
  100% {
    border-radius: 100%;
  }
}

.box_txt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(var(--box-width) - 6%);
  height: calc(var(--box-width) - 6%);
  background: var(--circleColor);
  border-radius: 100%;
}
.box_txt:before,
.box_txt:after {
  position: absolute;
  left: -1%;
  top: -1%;
  width: 102%;
  height: 102%;
  background: var(--circleColor);
  border-radius: 100%;
  content: "";
  opacity: 0.5;
}
.box_txt:before {
  animation: rotate360 4s linear infinite, radius_ani 6s linear infinite;
}
.box_txt:after {
  animation: rotate360 3s linear infinite, radius_ani 5s linear infinite;
}

.box_txt > div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  font-size: 24px;
  color: #777;
}
</style>
<style lang="scss"></style>
